import React, { Suspense, useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';

/*
 * Ekranın altındaki bölümleri, görünüme yaklaşınca (rootMargin) yükler ve gösterir.
 * Kodu ayrı parçada (React.lazy) olan bölümler de ancak bu noktada indirilir; API istekleri de o zaman başlar.
 * Yer tutucu yaklaşık yükseklik ayırır: içerik, görünür alana girmeden yerleştiği için kayma (CLS) olmaz.
 * IntersectionObserver yoksa (eski tarayıcı, bazı botlar) hemen gösterir.
 */
const LazySection = ({ children, minHeight = 480, rootMargin = '600px 0px', id }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(() => typeof window === 'undefined' || !('IntersectionObserver' in window));

  useEffect(() => {
    if (visible) return undefined;
    const node = ref.current;
    if (!node) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [visible, rootMargin]);

  const placeholder = <Box aria-hidden sx={{ minHeight }} />;

  return (
    <Box ref={ref} id={id} sx={{ scrollMarginTop: { xs: 70, md: 80 } }}>
      {visible ? <Suspense fallback={placeholder}>{children}</Suspense> : placeholder}
    </Box>
  );
};

export default LazySection;
